import React, { HTMLAttributes } from 'react';

import classname from '@search/classname/src';

import './styles.css';

interface IVasesIconsProps extends HTMLAttributes<HTMLDivElement> {
    hasTop?: boolean;
    hasHightlight?: boolean;
}

const cn = classname.bind(null, 'VasesIcons');

export const VasesIcons = ({
    className,
    hasHightlight = false,
    hasTop = false
}: IVasesIconsProps) => {
    return (
        <div className={cn('', undefined, className)}>
            {Boolean(hasTop) && (
                <div className={cn('vasTop')} />
            )}
            {Boolean(hasHightlight) && (
                <div className={cn('vasHighlight', { isSecondVas: hasTop })} />
            )}
        </div>
    );
};
